import { reactive } from "vue"

export const store = reactive({
    showSidebar: true,
    showHeader: true,
    showBackButton: false,
    user: null
})
